import { render, staticRenderFns } from "./overview.vue?vue&type=template&id=82345c5a&scoped=true"
import script from "./overview.vue?vue&type=script&lang=js"
export * from "./overview.vue?vue&type=script&lang=js"
import style0 from "./overview.vue?vue&type=style&index=0&id=82345c5a&prod&lang=css"
import style1 from "./overview.vue?vue&type=style&index=1&id=82345c5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82345c5a",
  null
  
)

export default component.exports